// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper-tags{margin-bottom:40px}.wrapper-tags .el-tag{border-color:#409eff;border-radius:20px;cursor:pointer}.wrapper-tags .el-tag+.el-tag{margin-left:5px}.wrapper-tags .el-tag:hover{color:#134f8c}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
